export var dataHooks = {
  RadioButtonWrapper: 'RadioButton-wrapper',
  RadioButtonInput: 'RadioButton-input',
  RadioButtonLabel: 'RadioButton-label',
  RadioButtonRadio: 'RadioButton-radio',
  RadioButtonChildren: 'RadioButton-children',
  RadioButtonContent: 'RadioButton-content'
};